export var UserStatus;
(function (UserStatus) {
  UserStatus["APPROVED"] = "APPROVED";
  UserStatus["PENDING"] = "PENDING";
  UserStatus["REJECTED"] = "REJECTED";
  UserStatus["PREAPPROVED"] = "PREAPPROVED";
  UserStatus["VETTING"] = "VETTING";
  UserStatus["BLOCKED"] = "BLOCKED";
})(UserStatus || (UserStatus = {}));